import React from 'react';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

export default function PaginationRound({
  type,
  count,
  page,
  onPageChange,
  color = "primary",
  rowsPerPage,
  onRowsPerPageChange
}) {
  const handlePageChange = (event, value) => {
  onPageChange(event, value-1);
 };

  return (
    <Stack spacing={2} direction="row" alignItems="center" justifyContent="flex-end" sx={{padding:{xs:1, sm:1, md:2} }}>
  
      <Select
      value={rowsPerPage}
      onChange={onRowsPerPageChange}
      size="small"
    >
      {[10, 25, 100].map((option) => (
        <MenuItem key={option} value={option}>
          {option}
        </MenuItem>
      ))}
    </Select>
  
      <Pagination
        variant="outlined"
        shape="rounded"
        color={color}
        count={Math.max(1, Math.ceil(count))}
        page={page}
        onChange={handlePageChange}
      />
    </Stack>


  );
}